import * as React from "react";
import { IconProps } from "./CalendarIcon";

export const MenuClosedIcon = React.forwardRef<SVGSVGElement, IconProps>(
    ({ size = 21, title, ...props }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 21 10"
                width={size}
                height={size}
                fill="none"
                role="img"
                aria-hidden={title ? undefined : true}
                {...props}
            >
                {title && <title>{title}</title>}
                <path
                    fill="currentColor"
                    d="M19.6667 8c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h10.6667Zm0-8c.5523 0 1 .4477 1 1s-.4477 1-1 1H1c-.5523 0-1-.4477-1-1s.4477-1 1-1h18.6667Z"
                />
            </svg>
        );
    }
);

MenuClosedIcon.displayName = "MenuClosedIcon";
